import React from 'react';

// ChatSidebar context view component showing current context details,
// capabilities, suggested actions, and context history
// Extracted from ChatSidebar.jsx lines 1073-1198
const ChatContextView = ({ currentContext, darkMode, onSuggestionClick }) => {
  return (
    <div className="flex-1 p-4 space-y-4 overflow-y-auto scrollbar-modern">
      {/* Current Context Details */}
      <div>
        <h3 className={`font-medium text-sm mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
          Current Context
        </h3>
        <div className={`
          p-3 rounded-lg text-sm space-y-2
          ${darkMode ? 'bg-gray-800 text-gray-300 border border-gray-700' : 'bg-gray-100 text-gray-600 border border-gray-200'}
        `}>
          <div className="flex items-center gap-2">
            <span className="font-medium">Type:</span>
            <span className="capitalize">{currentContext?.type?.replace('_', ' ')}</span>
          </div>
          {currentContext?.page && (
            <div className="flex items-start gap-2">
              <span className="font-medium">Page:</span>
              <span className="text-xs break-all">{currentContext.page}</span>
            </div>
          )}
          <div className="pt-1 border-t border-current border-opacity-20">
            <div className="text-xs">{currentContext?.summary}</div>
          </div>
        </div>
      </div>

      {/* Available Capabilities */}
      {currentContext?.capabilities && (
        <div>
          <h3 className={`font-medium text-sm mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
            What I can help with
          </h3>
          <div className="space-y-1">
            {currentContext.capabilities.map((capability, index) => (
              <div
                key={index}
                className={`
                  flex items-center gap-2 px-2 py-1 rounded text-xs
                  ${darkMode ? 'text-gray-400' : 'text-gray-600'}
                `}
              >
                <svg className="w-3 h-3 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                {capability}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Context-Aware Quick Actions */}
      <div>
        <h3 className={`font-medium text-sm mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
          Suggested Questions
        </h3>
        <div className="space-y-2">
          {(currentContext?.utils?.getSuggestedActions() || [
            'Analyze my website performance',
            'What are my biggest SEO opportunities?', 
            'Help me prioritize my SEO efforts'
          ]).map((action, index) => (
            <button
              key={index}
              onClick={() => onSuggestionClick(action)}
              className={`
                w-full text-left px-3 py-2 rounded-lg text-sm transition-all duration-200
                ${darkMode 
                  ? 'bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700 hover:border-purple-500' 
                  : 'bg-white text-gray-600 hover:bg-purple-50 border border-gray-200 hover:border-purple-300'
                }
              `}
            >
              💬 {action}
            </button>
          ))}
        </div>
      </div>

      {/* Context History */}
      {currentContext?.history && currentContext.history.length > 1 && (
        <div>
          <h3 className={`font-medium text-sm mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
            Recent Context Changes
          </h3>
          <div className="space-y-1">
            {currentContext.history.slice(-3).reverse().map((historyItem, index) => (
              <div
                key={index}
                className={`
                  text-xs p-2 rounded
                  ${index === 0 
                    ? darkMode 
                      ? 'bg-blue-900/30 text-blue-300 border border-blue-800' 
                      : 'bg-blue-50 text-blue-700 border border-blue-200'
                    : darkMode 
                      ? 'bg-gray-800/50 text-gray-400 border border-gray-700' 
                      : 'bg-gray-50 text-gray-500 border border-gray-200'
                  }
                `}
              >
                <div className="flex items-center gap-1">
                  {index === 0 && <span>📍</span>}
                  <span className="font-medium capitalize">
                    {historyItem.type.replace('_', ' ')}
                  </span>
                </div>
                <div className="truncate">
                  {historyItem.summary}
                </div>
                <div className="text-xs opacity-75 mt-1">
                  {new Date(historyItem.timestamp).toLocaleTimeString([], { 
                    hour: '2-digit', 
                    minute: '2-digit' 
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatContextView;
